export const otherError = 'Произошла ошибка получения данных'